import mock from "./mock";
import "./apps/dataView";
import "./navbar/navbarSearch";
import "./navbar/navbarBookmarkSearch";
import "./auth/authentication";

mock.onAny().passThrough();
